'use client'

import { Skeleton } from '@src/components/Skeleton/Skeleton'

export function SocialLadderSkeleton() {
  return (
    <Skeleton.Wrapper className="mx-auto flex max-w-full flex-col px-10 py-8 pt-6 lg:max-w-2xl lg:px-0 lg:pt-4">
      <div className="flex items-center justify-center gap-3 lg:hidden">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton.Block key={index} className="aspect-square size-16" />
        ))}
      </div>
      <div className="mt-3 flex items-center justify-center gap-3 lg:hidden">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton.Block key={index} className="aspect-square size-16" />
        ))}
      </div>
      <div className="hidden items-center justify-between gap-8 lg:flex">
        {Array.from({ length: 7 }).map((_, index) => (
          <Skeleton.Block key={index} className="aspect-square size-16" />
        ))}
      </div>
      <div className="my-5 h-px bg-bodi-gray-light lg:my-4"></div>
      <div className="flex flex-col">
        <Skeleton.Block className="h-56 w-full" />
        <div className="my-5 h-px bg-bodi-gray-light lg:my-4"></div>
        <Skeleton.Block className="h-56 w-full" />
      </div>
    </Skeleton.Wrapper>
  )
}
